import React from 'react';
import './ShareOtherComponent.scss'
import SharePicComponent from "../SharePicComponent/SharePicComponent";
import ShareUserPicComponent from "../SharePicComponent/ShareUserPicComponent";
import {getSessionCache, isInBocApp, setSessionCache} from "../../asstes/js/Utils";

class ShareOtherComponent extends React.Component {
	state = {
		bgImg: false,
		canvasWidth: getSessionCache('canvasWidth') || 0,
		canvasHeight: getSessionCache('canvasHeight') || 0,
		canvasImgLoad: false
	}

	imgLoad = (e) => {
		let {canvasWidth, canvasHeight} = this.state
		if (canvasWidth === 0) {
			canvasWidth = e.target.width
			canvasHeight = e.target.height
			setSessionCache('canvasWidth', e.target.width)
			setSessionCache('canvasHeight', e.target.height)
		}
		this.setState({
			bgImg: true,
			canvasWidth: canvasWidth,
			canvasHeight:canvasHeight
		})
	}

	isLoad = () => {
		this.setState({
			canvasImgLoad: true
		})
	}

	close = () => {
		this.props.hidePost && this.props.hidePost()
	}

	render() {
		const bg = require(`./test.png`)
		const closeIcon = require('../../asstes/img/other/close.png')
		let {createPostUrl, cashValue} = this.props
		const {bgImg, canvasWidth, canvasHeight, canvasImgLoad} = this.state

		return <div className="share-other-container">
			<p className="prompt"></p>
			<div className="img-absolute">
				<img className="share-other-bg" src={bg} onLoad={this.imgLoad} alt=""/>
				{
					bgImg ?
						<div className="share-canvas-container flex-center-center">
							{
								canvasImgLoad ?
									<div>
										<img className="share-canvas-close" src={closeIcon} onClick={this.close} alt=""/>
										<div className="share-canvas-bottom-text flex-center-center">
											{
												!isInBocApp() ? '长按图片或截屏保存到相册' : '截屏保存到相册'
											}
										</div>
									</div> : null
							}
							{
								cashValue ?
									<ShareUserPicComponent cashValue={cashValue} canvasWidth={canvasWidth} canvasHeight={canvasHeight} createPostUrl={createPostUrl} isLoad={this.isLoad}/> :
									<SharePicComponent canvasWidth={canvasWidth} canvasHeight={canvasHeight} createPostUrl={createPostUrl} isLoad={this.isLoad}/>
							}
						</div> : null
				}
			</div>
		</div>
	}
}

export default ShareOtherComponent;
